import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonSettingsKeys, TeamLeadCommissionCommonSettings } from '@p2p/platform-settings/domain';

import { SETTINGS_FORM_GROUP_NAME } from '../../constants';
import { UpsertUserData } from '../upsert-user';
import { UpsertUserTeamLead } from '../upsert-user-team-lead';
import { UserRole } from '../user-role';

import { UserBaseForm, UserBaseFormControls } from './user-base.form';

export enum UserTeamLeadFormControls {
    TeamLeadId = 'teamLeadId',
    TeamLeadPayinCommissionRate = 'teamLeadPayinCommissionRate',
    TeamLeadPayoutCommissionRate = 'teamLeadPayoutCommissionRate'
}

export class UserTeamLeadForm extends UserBaseForm {
    constructor() {
        super();
    }

    initForm(): void {
        this.form.get(UserBaseFormControls.Role)?.setValue(UserRole.TeamLead, { emitEvent: false });
        this.form.addControl(UserTeamLeadFormControls.TeamLeadId, new FormControl(null), { emitEvent: false });
        this.form.addControl(
            SETTINGS_FORM_GROUP_NAME,
            new FormGroup({
                [UserTeamLeadFormControls.TeamLeadPayinCommissionRate]: new FormControl('', [Validators.required]),
                [UserTeamLeadFormControls.TeamLeadPayoutCommissionRate]: new FormControl('', [Validators.required])
            }),
            { emitEvent: false }
        );
    }

    setSettingsData(settings: TeamLeadCommissionCommonSettings): void {
        const formGroup = this.form.get(SETTINGS_FORM_GROUP_NAME) as FormGroup;

        formGroup
            .get(UserTeamLeadFormControls.TeamLeadPayinCommissionRate)
            ?.setValue(settings[CommonSettingsKeys.TeamLeadPayinCommissionRate], { emitEvent: false });
        formGroup
            .get(UserTeamLeadFormControls.TeamLeadPayoutCommissionRate)
            ?.setValue(settings[CommonSettingsKeys.TeamLeadPayoutCommissionRate], { emitEvent: false });
    }

    override applyUserDetails(userDetails?: UpsertUserData) {
        const settings = userDetails?.settings as UpsertUserTeamLead;
        const settingsControl = this.form.get(SETTINGS_FORM_GROUP_NAME);

        settingsControl
            ?.get(UserTeamLeadFormControls.TeamLeadPayinCommissionRate)
            ?.setValue(settings.teamLeadPayinCommissionRate, { emitEvent: false });
        settingsControl
            ?.get(UserTeamLeadFormControls.TeamLeadPayoutCommissionRate)
            ?.setValue(settings.teamLeadPayoutCommissionRate, { emitEvent: false });

        super.applyUserDetails(userDetails);
    }
}
